import {MapTool} from '@apps-common/ui-maps';
import MapPopper from '@apps-common/ui-maps/MapPopper';
import GlobeIcon from '@mui/icons-material/Language';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import BoxZoom from './BoxZoom.jsx';
import MapPopperButton from './MapPopperButton.jsx';

import {setDrawTool} from '@app/actions/map';
import {MAP_TOOLS} from '@app/constants';
import useMapViewParams from '@app/hooks/useMapViewParams';

const AdditionalZoomTools = ({map, placement, ...props}) => {
  const dispatch = useDispatch();
  const {resetLocation} = useMapViewParams();

  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);

  const drawTool = useSelector(state => state.map.drawTool);

  const onClickZoomOutWorld = () => {
    resetLocation();
    setAnchorEl(null);
  };

  const onClickBoxZoom = () => {
    dispatch(
      setDrawTool({
        name:
          drawTool.name === MAP_TOOLS.BOX_ZOOM
            ? MAP_TOOLS.NONE
            : MAP_TOOLS.BOX_ZOOM,
      })
    );
  };

  return (
    <>
      <MapTool
        value="zoom-to-tools"
        tooltipTitle="Zoom tools"
        tooltipPosition="left-end"
        active={isOpen}
        icon={<ZoomInIcon />}
        onClick={event => {
          setAnchorEl(event.currentTarget);
        }}
        {...props}
      />

      <MapPopper
        title="Zoom tools"
        open={isOpen}
        anchorEl={anchorEl}
        placement={placement}
        onClose={() => setAnchorEl(null)}
      >
        <MapPopperButton
          onClick={onClickZoomOutWorld}
          tooltip="Zoom out to the world"
          tooltipPosition="top"
          data-testid="zoom-out-to-world"
        >
          <GlobeIcon />
        </MapPopperButton>
        <BoxZoom
          active={drawTool.name === MAP_TOOLS.BOX_ZOOM}
          map={map}
          onClick={onClickBoxZoom}
          onDeactivate={() => dispatch(setDrawTool(MAP_TOOLS.NONE))}
        />
      </MapPopper>
    </>
  );
};

AdditionalZoomTools.propTypes = {
  map: PropTypes.object,
  placement: PropTypes.string,
};

export default AdditionalZoomTools;
